import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.2, 0.8, 0.2, 1] }}
  >
    {children}
  </motion.div>
);

export const KineticLines = ({ lines, className = "" }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: 0.15 + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const Stat = ({ value, label }) => (
  <Reveal className="border-l-2 border-primary/30 pl-5">
    <div className="text-4xl sm:text-5xl font-display font-semibold tracking-tighter text-zinc-900">{value}</div>
    <div className="overline mt-2 !text-zinc-400">{label}</div>
  </Reveal>
);
